<template>
<div class="chapter">
<div class="inner_page">
<div id="V4039_ebook-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN" id="toc_marker-3"><span class="char-style-override-2">Also by Joseph Wambaugh</span></p>
<p class="Normal para-style-override-1"><span class="char-style-override-3">Novels</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The New Centurions</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Blue Knight</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Choirboys</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Black Marble</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Glitter Dome</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Delta Star</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Secrets of Harry Bright</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Golden Orange</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Fugitive Nights</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Finnegan’s Week</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Floaters</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Hollywood Station</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Hollywood Crows</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Hollywood Moon</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Hollywood Hills</span></p>
<p class="Normal para-style-override-1"><span class="char-style-override-3">Nonfiction</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Onion Field</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Lines and Shadows</span></p>
<p class="Normal para-style-override-3"><span class="char-style-override-4">Echoes in the Darkness</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">The Blooding: The True Story </span></p>
<p class="Normal para-style-override-3"><span class="char-style-override-4">of the Narborough Village Murders</span></p>
<p class="Normal para-style-override-2"><span class="char-style-override-4">Fire Lover: A True Story</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4039_ebook2.vue?ae94da04